/**
 * ⌘K qatorlari tartibi (sof funksiyalar, testi bilan):
 * - so'rov bo'sh: amallar, oxirgi driverlar, bo'limlar;
 * - so'rov bor: driverlar doim birinchi, keyin xodimlar, carrier'lar, vakansiyalar, so'ngra mos amallar va bo'limlar.
 * Bo'lim to'liq chiqmagan bo'lsa oxirida "Barchasini ko'rish (N)" -- ro'yxat sahifasi shu so'rov bilan ochiladi.
 */
import { matchesText } from "@/lib/textsearch";

export type Section = "actions" | "recent" | "drivers" | "people" | "carriers" | "jobs" | "goTo";

const EMPTY_ORDER: Section[] = ["actions", "recent", "goTo"];
const QUERY_ORDER: Section[] = ["drivers", "people", "carriers", "jobs", "actions", "goTo"];

export function sectionOrder(hasQuery: boolean): Section[] {
  return hasQuery ? QUERY_ORDER : EMPTY_ORDER;
}

/** Amal va bo'lim nomlari matn bo'yicha (lib/textsearch: tutuq belgilari, kirill); so'rov bo'sh bo'lsa hammasi mos */
export function matches(query: string, text: string): boolean {
  return matchesText(text, query);
}

/** Ko'rsatilmay qolganlar soni; 0 bo'lsa "Barchasini ko'rish" qatori kerak emas */
export function hiddenCount(count: number, shown: number): number {
  return Math.max(0, count - shown);
}

/** Ro'yxat sahifasi shu so'rov bilan (xodimlar sahifasida matn qidiruvi yo'q -- unga havola berilmaydi) */
export function listLink(section: "drivers" | "carriers" | "jobs", q: string): string {
  const value = encodeURIComponent(q.trim());
  if (section === "drivers") return `/drivers?q=${value}`;
  return `/${section}?search=${value}`;
}
